var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "shippingDetails"
  }, [_c('loader', {
    attrs: {
      "isLoading": _vm.isLoading
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 mb-1"
  }, [_c('div', {
    staticClass: "card-header filter_main"
  }, [_c('i', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.collapse1",
      modifiers: {
        "collapse1": true
      }
    }],
    staticClass: " fa fa-filter filter",
    attrs: {
      "data-toggle": "collapse",
      "aria-expanded": "true"
    }
  })]), _vm._v(" "), _c('b-collapse', {
    attrs: {
      "visible": "",
      "id": "collapse1"
    }
  }, [_c('b-card', [_c('div', {
    staticClass: "card-body1"
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "action": "",
      "method": "post"
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('common.orderID')))]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-cube'></i>"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('common.orderIDPlaceholder'),
      "name": "orderid",
      "id": "orderid"
    },
    model: {
      value: (_vm.orderid),
      callback: function($$v) {
        _vm.orderid = $$v
      },
      expression: "orderid"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('ShippingDetails.boxID')))]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-cube'></i>"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('ShippingDetails.boxIDPlaceHolder'),
      "name": "boxid",
      "id": "boxid"
    },
    on: {
      "keyup": _vm.checkboxid
    },
    model: {
      value: (_vm.boxid),
      callback: function($$v) {
        _vm.boxid = $$v
      },
      expression: "boxid"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "30px",
      "margin-left": "300px"
    }
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "disabled": _vm.isLoading
    },
    on: {
      "click": function($event) {
        _vm.getShipmentDetailsList()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" " + _vm._s(_vm.$t('common.searchBtn')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": _vm.resetFormData
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v("  " + _vm._s(_vm.$t('common.resetBtn')))])])])])])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-headerfrm"
  }, [_c('div', {
    staticClass: "form-group row",
    staticStyle: {
      "height": "20px"
    }
  }, [_c('div', {
    staticClass: "col-md-4 cardlistheader"
  }, [_c('h4', {
    staticClass: "header"
  }, [_c('i', {
    staticClass: "fa fa-bars barcolor",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('ShippingDetails.shippingDetails')))])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('table', {
    staticClass: "table-bordered datatables cardtable",
    attrs: {
      "id": "my-table"
    }
  }, [_c('thead', {
    staticClass: "theader"
  }, [_c('tr', {
    staticClass: "text-primary cardreporttablerow"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('common.orderID')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('ShippingDetails.boxID')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('ShippingDetails.awbNo')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('ShippingDetails.transporter')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('ShippingDetails.action')))])])]), _vm._v(" "), _c('tbody', [(_vm.resultCount == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "6",
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.noRecordFound')))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.listShipmentData), function(data, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.orderid))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.boxid))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.awbno))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.shippingcompany))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [(data.shipment_id == null || data.shipment_id == '') ? _c('i', {
      staticClass: "fa fa-edit text-successedit fa-lg mt-2 ml-3",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.UpdateShipping(data)
        }
      }
    }) : _vm._e(), _vm._v(" "), (data.shipment_id !== null || data.shipment_id !== '') ? _c('i', [_vm._v("-")]) : _vm._e()])])
  })], 2)])]), _c('br')])])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "modal-lg"
    },
    on: {
      "ok": function($event) {
        _vm.updateShippingmodal = false
      }
    },
    model: {
      value: (_vm.updateShippingmodal),
      callback: function($$v) {
        _vm.updateShippingmodal = $$v
      },
      expression: "updateShippingmodal"
    }
  }, [_c('form', {
    attrs: {
      "autocomplete": "off"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('b-card', [_c('div', {
    slot: "header"
  }, [(_vm.updateShipping == 'add') ? _c('span', {
    staticClass: "mdltitle"
  }, [_vm._v(_vm._s(_vm.$t('ShippingDetails.updateShippingDetails')))]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        _vm.closeupdateShippingmodal()
      }
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('fieldset', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_vm._v("\n                     "), _c('label', [_vm._v(_vm._s(_vm.$t('common.orderID')))]), _vm._v(" \n                  "), _c('span', [_vm._v(_vm._s(_vm.editshipping.orderid))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('ShippingDetails.boxID')))]), _vm._v(" \n                  "), _c('span', [_vm._v(_vm._s(_vm.editshipping.boxid))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_vm._v("\n                     "), _c('label', [_vm._v(_vm._s(_vm.$t('ShippingDetails.transporter')))]), _vm._v(" \n                  "), _c('span', [_vm._v(_vm._s(_vm.editshipping.transporter))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('ShippingDetails.awbNo')))]), _vm._v(" \n                  "), _c('span', [_vm._v(_vm._s(_vm.editshipping.correctAWB))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('ShippingDetails.CorrectTransporter')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-window-maximize'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editshipping.transporter),
      expression: "editshipping.transporter"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('transporter')
    },
    attrs: {
      "name": "transporter",
      "id": "transporter"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.editshipping.transporter = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('ShippingDetails.selectTransporter')))]), _vm._v(" "), _vm._l((_vm.transporterList), function(transporter) {
    return _c('option', {
      domProps: {
        "value": transporter.couriername
      }
    }, [_vm._v(_vm._s(transporter.couriername))])
  })], 2)]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('transporter')),
      expression: "errors.has('transporter')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.$t('ShippingDetails.validateTransporter')) + "\n                  ")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('ShippingDetails.correctAWB')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-industry'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editshipping.correctAWB),
      expression: "editshipping.correctAWB"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('correct AWB')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('ShippingDetails.correctAWBPlaceholder'),
      "name": "correct AWB",
      "id": "correctAWB"
    },
    domProps: {
      "value": _vm.correctAWB,
      "value": (_vm.editshipping.correctAWB)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.editshipping.correctAWB = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('correct AWB')),
      expression: "errors.has('correct AWB')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.$t('ShippingDetails.validatecorrectAWB')) + "\n                  ")])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-left": "350px"
    }
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit",
      "disabled": _vm.isLoading
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" " + _vm._s(_vm.$t('common.saveBtn')))])])], 1)])])], 1)])])], 1)], 1)
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-952aefea", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-952aefea","hasScoped":true}!./src/views/components/shippingDetails/shippingDetails.component.html
// module id = 845
// module chunks = 0